export const DEMO_WORKSPACE_SEEDS = new Set([
  "snowspire-demo-institute-v1",
  "smbc-demo-institute-v1",
  "maryfield-school-demo-v1",
  "afrirun-institute-demo-v1",
  "just-us-institute-demo-v1",
]);

const DEMO_WORKSPACE_SEED_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*-demo-(?:institute-)?v\d+$/i;

export const isDemoWorkspaceSettings = (settings = {}) => (
  DEMO_WORKSPACE_SEED_PATTERN.test(String(settings?.demo_seed || "").trim())
);

export const isSchoolDemoWorkspace = (settings = {}) => {
  if (!isDemoWorkspaceSettings(settings)) return false;
  const category = String(settings?.category || settings?.segment || "").trim().toLowerCase();
  return category === "school" || /-school-demo-(?:institute-)?v\d+$/i.test(String(settings?.demo_seed || "").trim());
};

export const isCollegeDemoWorkspace = (settings = {}) => (
  isDemoWorkspaceSettings(settings)
  && String(settings?.category || settings?.segment || "").trim().toLowerCase() === "college"
);

const fullName = (row = {}) => (
  [row.name, row.surname].filter(Boolean).join(" ").trim() || row.username || "Member"
);

export const buildDemoWorkspaceMembers = (memberships = [], profiles = []) => {
  const profileById = new Map((profiles || []).map((profile) => [String(profile.id), profile]));

  return (memberships || [])
    .map((membership) => {
      const profile = profileById.get(String(membership.demo_profile_id));
      if (!profile) return null;
      return {
        id: profile.id,
        name: fullName(profile),
        image: profile.profile_img || null,
        steps: Number(membership.steps || 0),
      };
    })
    .filter(Boolean)
    .sort((a, b) => Number(b.steps || 0) - Number(a.steps || 0));
};

export const buildDemoWorkspaceChallenges = (institutes = [], memberships = []) => {
  const challengeById = new Map(
    (institutes || [])
      .filter((institute) => String(institute?.institute_type || '').toLowerCase() === 'challenge')
      .map((institute) => [String(institute.id), institute]),
  );
  const stepsById = new Map();
  (memberships || []).forEach((membership) => {
    const id = String(membership?.institute_id || '');
    if (!challengeById.has(id)) return;
    stepsById.set(id, (stepsById.get(id) || 0) + Number(membership?.steps || 0));
  });

  return Array.from(challengeById.entries())
    .map(([id, institute]) => ({
      id,
      name: institute.name || 'Workspace challenge',
      image: institute.image_url || institute.brand_logo_url || null,
      steps: stepsById.get(id) || 0,
      kind: 'challenge',
    }))
    .sort((a, b) => Number(b.steps || 0) - Number(a.steps || 0));
};

export const mergeDemoWorkspaceGroupTotals = (teams = [], memberships = [], demoProfileIds = []) => {
  const allowedProfiles = new Set(demoProfileIds.map(String));
  const totals = new Map();
  (memberships || []).forEach((row) => {
    const teamId = String(row?.team_id || '');
    if (!teamId || !allowedProfiles.has(String(row?.demo_profile_id || ''))) return;
    const current = totals.get(teamId) || { steps: 0, members: new Set() };
    current.steps += Number(row.steps || 0);
    current.members.add(String(row.demo_profile_id));
    totals.set(teamId, current);
  });
  return (teams || []).map((team) => {
    if (team?.kind === 'challenge') return team;
    const total = totals.get(String(team?.id || ''));
    return total ? { ...team, steps: total.steps, member_count: total.members.size } : { ...team, steps: 0, member_count: 0 };
  });
};
